function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var _ref2 = /*#__PURE__*/React.createElement("path", {
  opacity: 0.4,
  d: "M16.34 2H7.67C4.28 2 2 4.38 2 7.92V16.09C2 19.62 4.28 22 7.67 22H16.34C19.73 22 22 19.62 22 16.09V7.92C22 4.38 19.73 2 16.34 2Z",
  fill: "#8B8B8B"
});
var _ref3 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M11.1246 8.18945C11.1246 8.67145 11.5156 9.06445 11.9946 9.06445C12.4876 9.06445 12.8796 8.67145 12.8796 8.18945C12.8796 7.70745 12.4876 7.31445 12.0046 7.31445C11.5196 7.31445 11.1246 7.70745 11.1246 8.18945ZM12.8696 11.3623C12.8696 10.8803 12.4766 10.4873 11.9946 10.4873C11.5126 10.4873 11.1196 10.8803 11.1196 11.3623V15.7823C11.1196 16.2643 11.5126 16.6573 11.9946 16.6573C12.4766 16.6573 12.8696 16.2643 12.8696 15.7823V11.3623Z",
  fill: "#8B8B8B"
});
function SvgInfoSquare(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoSquare);
export default __webpack_public_path__ + "static/media/InfoSquare.112b1e86.svg";
export { ForwardRef as ReactComponent };